import { render } from "./LoginPage.vue?vue&type=template&id=fbc7c130&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=fbc7c130&scoped=true&lang=css"

import exportComponent from "/Users/michael/Desktop/Development/vue/login/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc7c130"]])

export default __exports__